// 奥运会顶部菜单

module.exports = {
  sportType: 'compreSportsMeet',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        // {
        //   name: '赛程',
        //   key: 'schedule',
        //   routeName: 'CSMeetScheduleIndex_WOG',
        //   act: true,
        // },
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'CSMeetScheduleIndex_WOG',
          act: true,
          child: [
            {
              name: '常规赛程',
              key: 'regularSchedule',
              routeName: 'CSMeetRegularScheduleIndex_WOG',
              act: false,
            },
            {
              name: '运动员赛程',
              key: 'playersSchedule',
              act: false,
              routeName: 'CSMeetEventPlayersScheduleIndex_WOG',
            },
            {
              name: '项目阶段',
              key: 'eventPhase',
              act: false,
              routeName: 'CSMeetEventPhaseIndex_WOG',
            },
          ],
        },
        {
          name: '项目',
          key: 'bigSports',
          routeName: 'CSMeetBigSportsIndex_WOG',
          act: false,
        },
        {
          name: '奖牌',
          key: 'medal',
          routeName: 'CSMeetMedalIndex_WOG',
          act: false,
          child: [
            {
              name: '奖牌榜',
              key: 'medalTally',
              routeName: 'CSMeetMedalTallyIndex_WOG',
              act: false,
            },
            {
              name: '奖牌明细',
              key: 'medalDetailList',
              act: false,
              routeName: 'CSMeetMedalDetailListIndex_WOG',
            },
          ],
        },
        {
          name: '代表团',
          key: 'delegation',
          routeName: 'CSMeetDelegationIndex_WOG',
          act: false,
        },
        {
          name: '运动员',
          key: 'player',
          routeName: 'CSMeetPlayerIndex_WOG',
          act: false,
        },
        {
          name: '纪录',
          key: 'record',
          routeName: 'CSMeetRecordIndex_WOG',
          act: false,
        },
        {
          name: '场馆',
          key: 'venue',
          routeName: 'CSMeetVenueIndex_WOG',
          act: false,
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'CSMeetProgramListIndex_WOG',
          act: false,
          isOpenWeb: false,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'CSMeetBroadcastListIndex_WOG',
          act: false,
          isOpenWeb: false,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'CSMeetDataPackagListIndex_WOG',
          act: false,
          isOpenWeb: false,
        },
      ],
    },
  ],
}
